import { RegisterPos } from '@/domain/models/Pos';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { PosService, uploadParams } from '@/services/Pos';

export const usePosUpload = (): ((
  providerId: number,
  uploadData: RegisterPos[]
) => Promise<void>) => {
  const posService = new PosService(getClient());

  const posDataUpload = async (
    providerId: number,
    uploadData: RegisterPos[]
  ) => {
    const body: uploadParams = {
      providerId,
      uploadData,
    };
    return await posService
      .upload(body)
      .catch((error: Error) => errorHandler({ error }));
  };

  return posDataUpload;
};
